import React from 'react';
import HeroSection from './components/HeroSection';
import FlowchartSection from './components/FlowchartSection';
import FeaturesSection from './components/FeaturesSection';
import SignupSection from './components/SignupSection';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Top hero section with logo and product description */}
      <HeroSection />
      {/* Diagram explaining how the service works */}
      <FlowchartSection />
      {/* Key features overlayed on a background image */}
      <FeaturesSection />
      {/* Waitlist sign‑up form */}
      <SignupSection />
      <footer className="site-footer">
        <div className="site-footer__inner">
          <div className="site-footer__column">
            <p><strong>WisyGuide srl</strong></p>
            <p><strong>P.IVA</strong> 04841090402</p>
            <p><strong>C.F.</strong> 04841090402</p>
          </div>
          <div className="site-footer__column">
            <p>
              <strong>Indirizzo:</strong>{' '}
              <a
                href="https://maps.app.goo.gl/2Anz9zLXtZEqKZ59A"
                className="site-footer__link"
                rel="noopener noreferrer"
                target="_blank"
              >
                <br />Via Circonvallazione Occidentale 98/N, 47923 Rimini (RN)
              </a>
            </p>
            <p>
              <strong>Contatti:</strong>{' '}
              <a href="mailto:info@wisyguide.ai" className="site-footer__link">
                info@wisyguide.ai
              </a>
            </p>
          </div>
          <div className="site-footer__column site-footer__social">
            <p className="site-footer__title">Social</p>
            <div className="site-footer__icons">
              <a
                href="https://www.linkedin.com/company/wisyguide?trk=public_post_follow-view-profile"
                aria-label="LinkedIn"
                className="site-footer__icon"
                rel="noopener noreferrer"
                target="_blank"
              >
                <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
                  <path d="M4.98 3.5c0 1.38-1.11 2.5-2.49 2.5S0 4.88 0 3.5 1.11 1 2.49 1 4.98 2.12 4.98 3.5zM.5 23.5h4V7.9h-4v15.6zM8.5 7.9h3.8v2.1h.1c.5-1 1.8-2.1 3.7-2.1 4 0 4.7 2.6 4.7 6v9.6h-4v-8.5c0-2-.1-4.6-2.8-4.6-2.8 0-3.3 2.2-3.3 4.4v8.7h-4V7.9z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/wisyguide/"
                aria-label="Instagram"
                className="site-footer__icon"
                rel="noopener noreferrer"
                target="_blank"
              >
                <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
                  <path d="M12 7.3A4.7 4.7 0 1 0 12 16.7 4.7 4.7 0 0 0 12 7.3zm0 7.7A3 3 0 1 1 12 9a3 3 0 0 1 0 6.0zM17.6 6.1a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z" />
                  <path d="M7.2 2h9.6A5.2 5.2 0 0 1 22 7.2v9.6A5.2 5.2 0 0 1 16.8 22H7.2A5.2 5.2 0 0 1 2 16.8V7.2A5.2 5.2 0 0 1 7.2 2zm0 2A3.2 3.2 0 0 0 4 7.2v9.6A3.2 3.2 0 0 0 7.2 20h9.6A3.2 3.2 0 0 0 20 16.8V7.2A3.2 3.2 0 0 0 16.8 4z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
